import { gql } from "@apollo/client";

// Feature tours (registry §36.5). Kept beside the engine rather than in the
// shared queries.js / mutations.js so the whole feature lives in one folder.

export const MY_TOURS = gql`
  query MyTours($platform: String!) {
    myTours(platform: $platform) {
      enabled
      items {
        id
        title
        summary
        releasedAt
        startMode
        isNew
        isPreview
        assigned
        seenAt
        completedAt
        poppedAt
      }
    }
  }
`;

export const MARK_TOURS_SEEN = gql`
  mutation MarkToursSeen($tourIds: [String!]!, $via: String!) {
    markToursSeen(tourIds: $tourIds, via: $via)
  }
`;

export const MARK_TOUR_COMPLETED = gql`
  mutation MarkTourCompleted($tourId: String!) {
    markTourCompleted(tourId: $tourId)
  }
`;

export const MARK_TOURS_POPPED = gql`
  mutation MarkToursPopped($tourIds: [String!]!) {
    markToursPopped(tourIds: $tourIds)
  }
`;

export const LOG_TOUR_EVENTS = gql`
  mutation LogTourEvents($events: [TourEventInput!]!) {
    logTourEvents(events: $events)
  }
`;

// Admin Walkthroughs page (registry §36.10). Only what the page renders.
// No platform argument = both platforms in one load; the page's tabs filter.
export const TOUR_REPORT = gql`
  query TourReport($platform: String) {
    tourReport(platform: $platform) {
      platform
      enabled
      generatedAt
      tours {
        id
        platform
        title
        summary
        roles
        releasedAt
        isPreview
        releaseOverride
        counts {
          eligible
          completed
          started
          dismissed
          notSeen
          popped
        }
        steps {
          stepIndex
          event
          reason
          count
          users
        }
        users {
          userId
          name
          status
          isNew
          assigned
          assignedAt
          seenAt
          completedAt
          lastExitStep
          lastExitReason
        }
      }
    }
  }
`;

// Admin assignment (registry §36.5): one call per person. The server rejects
// ids the person's roles don't hold and skips tours they already completed.
export const ASSIGN_TOURS = gql`
  mutation AssignTours($userId: String!, $tourIds: [String!]!) {
    assignTours(userId: $userId, tourIds: $tourIds) {
      assigned
      skippedCompleted
      rejected
    }
  }
`;

// true only when an assignment existed (a stale row reads "already unassigned").
export const UNASSIGN_TOUR = gql`
  mutation UnassignTour($userId: String!, $tourId: String!) {
    unassignTour(userId: $userId, tourId: $tourId)
  }
`;

// "Release now" / "Back to preview" (registry §36.11): a preview tour goes
// live from the page with no deploy, and can be put back.
export const RELEASE_TOUR = gql`
  mutation ReleaseTour($tourId: String!) {
    releaseTour(tourId: $tourId)
  }
`;

export const UNRELEASE_TOUR = gql`
  mutation UnreleaseTour($tourId: String!) {
    unreleaseTour(tourId: $tourId)
  }
`;
